import * as Types from '../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetChoiceByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetChoiceByIdQuery = { __typename?: 'Query', choice: { __typename?: 'Choice', id: string, config: any, approvedAt?: any | null, submittedAt?: any | null, createdAt: any, status: Types.ChoiceStatus, product: { __typename?: 'Product', id: string, name: string, image: string, color: string, fields: Array<{ __typename?: 'ProductField', fallback?: string | null, label: string, path?: string | null, tag?: Types.ProductFieldTag | null, type: Types.ProductFieldType }> }, formInputs: Array<{ __typename?: 'FormInput', key: string, value: any }>, employee: { __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, firstname: string, lastname: string }, company: { __typename?: 'Company', id: string } } } };

export type GetPaymentOrdersQueryVariables = Types.Exact<{
  budgetId: Types.Scalars['ID']['input'];
  employeeId: Types.Scalars['ID']['input'];
  choiceId: Types.Scalars['ID']['input'];
}>;


export type GetPaymentOrdersQuery = { __typename?: 'Query', paymentOrders: Array<{ __typename?: 'PaymentOrder', id: string, expectedAmount: number, dueDate: any, committed: boolean, fulfilled: boolean, budget: { __typename?: 'Budget', id: string, name: { __typename?: 'LocalizedText', en: string, fr?: string | null, nl?: string | null } }, transactions: Array<{ __typename?: 'Transaction', id: string, amount: number, createdAt: any }> }> };


export const GetChoiceByIdDocument = gql`
    query GetChoiceById($id: ID!) {
  choice(id: $id) {
    id
    config
    approvedAt
    submittedAt
    createdAt
    product {
      id
      name
      image
      color
      fields {
        fallback
        label
        path
        tag
        type
      }
    }
    status
    formInputs {
      key
      value
    }
    employee {
      id
      user {
        id
        firstname
        lastname
      }
      company {
        id
      }
    }
  }
}
    `;

/**
 * __useGetChoiceByIdQuery__
 *
 * To run a query within a React component, call `useGetChoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChoiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetChoiceByIdQuery, GetChoiceByIdQueryVariables> & ({ variables: GetChoiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChoiceByIdQuery, GetChoiceByIdQueryVariables>(GetChoiceByIdDocument, options);
      }
export function useGetChoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChoiceByIdQuery, GetChoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChoiceByIdQuery, GetChoiceByIdQueryVariables>(GetChoiceByIdDocument, options);
        }
export function useGetChoiceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChoiceByIdQuery, GetChoiceByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChoiceByIdQuery, GetChoiceByIdQueryVariables>(GetChoiceByIdDocument, options);
        }
export type GetChoiceByIdQueryHookResult = ReturnType<typeof useGetChoiceByIdQuery>;
export type GetChoiceByIdLazyQueryHookResult = ReturnType<typeof useGetChoiceByIdLazyQuery>;
export type GetChoiceByIdSuspenseQueryHookResult = ReturnType<typeof useGetChoiceByIdSuspenseQuery>;
export type GetChoiceByIdQueryResult = Apollo.QueryResult<GetChoiceByIdQuery, GetChoiceByIdQueryVariables>;
export const GetPaymentOrdersDocument = gql`
    query GetPaymentOrders($budgetId: ID!, $employeeId: ID!, $choiceId: ID!) {
  paymentOrders(
    paymentOrderArgs: {budgetId: $budgetId, choiceId: $choiceId, employeeId: $employeeId}
  ) {
    id
    expectedAmount
    dueDate
    committed
    fulfilled
    budget {
      id
      name {
        en
        fr
        nl
      }
    }
    transactions {
      id
      amount
      createdAt
    }
  }
}
    `;

/**
 * __useGetPaymentOrdersQuery__
 *
 * To run a query within a React component, call `useGetPaymentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentOrdersQuery({
 *   variables: {
 *      budgetId: // value for 'budgetId'
 *      employeeId: // value for 'employeeId'
 *      choiceId: // value for 'choiceId'
 *   },
 * });
 */
export function useGetPaymentOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables> & ({ variables: GetPaymentOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables>(GetPaymentOrdersDocument, options);
      }
export function useGetPaymentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables>(GetPaymentOrdersDocument, options);
        }
export function useGetPaymentOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables>(GetPaymentOrdersDocument, options);
        }
export type GetPaymentOrdersQueryHookResult = ReturnType<typeof useGetPaymentOrdersQuery>;
export type GetPaymentOrdersLazyQueryHookResult = ReturnType<typeof useGetPaymentOrdersLazyQuery>;
export type GetPaymentOrdersSuspenseQueryHookResult = ReturnType<typeof useGetPaymentOrdersSuspenseQuery>;
export type GetPaymentOrdersQueryResult = Apollo.QueryResult<GetPaymentOrdersQuery, GetPaymentOrdersQueryVariables>;